/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function MapPin({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_1331_43865)">
                <path d="M7.99979 0.488284C6.78434 0.487145 5.59174 0.805312 4.55119 1.40832C3.51065 2.01132 2.66183 2.87617 2.0967 3.90917C1.53158 4.94216 1.27169 6.10392 1.3452 7.26856C1.41871 8.43321 1.82282 9.55634 2.51373 10.5163C2.54139 10.5684 2.57492 10.6175 2.61374 10.6627L2.71374 10.7795C2.80708 10.8955 2.90291 11.0075 2.98542 11.0995L7.35643 16.1987C7.43481 16.2895 7.53313 16.3625 7.64435 16.4126C7.75557 16.4627 7.87695 16.4885 7.99979 16.4883C8.12298 16.4883 8.24464 16.4622 8.35603 16.4117C8.46742 16.3612 8.56577 16.2876 8.64399 16.1963L12.8875 11.2323C13.0594 11.0549 13.2202 10.8679 13.3692 10.6723L13.475 10.5483C13.5153 10.5013 13.5495 10.4497 13.5767 10.3947C14.2353 9.42936 14.6097 8.31106 14.6604 7.15817C14.7111 6.00528 14.4361 4.86067 13.8647 3.84551C13.2932 2.83034 12.4464 1.98239 11.4139 1.39139C10.3815 0.8004 9.20185 0.488354 7.99979 0.488284ZM7.99979 4.48828C8.49427 4.48828 8.97764 4.62904 9.38878 4.89276C9.79992 5.15647 10.1204 5.5313 10.3096 5.96984C10.4988 6.40838 10.5483 6.89094 10.4519 7.3565C10.3554 7.82205 10.1173 8.24969 9.76764 8.58534C9.41799 8.92098 8.97251 9.14956 8.48754 9.24217C8.00257 9.33477 7.49988 9.28724 7.04305 9.10559C6.58621 8.92394 6.19575 8.61633 5.92103 8.22165C5.64632 7.82697 5.49969 7.36296 5.49969 6.88828C5.49969 6.25176 5.76309 5.64131 6.23195 5.19123C6.70081 4.74114 7.33673 4.48828 7.99979 4.48828Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1331_43865">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.488281)" />
                </clipPath>
            </defs>
        </svg>
    );
}
